module.exports = __webpack_public_path__ + "img/Qaser.855a7e13.jpeg";